export default function (arr, key = 'id') {
  if (!arr?.length) return null

  return arr
    .map(item => item[key])
}
